document.addEventListener("DOMContentLoaded", function () {

  //console.log("✅ DOM Loaded");

  var tabs = document.querySelectorAll('.gf_tab');
  var panels = document.querySelectorAll('.gf_tab-panel');

  //console.log("📌 Total Tabs:", tabs.length);
  //console.log("📌 Total Panels:", panels.length);

  /* =========================
     STEP 1: HIDE EMPTY TABS
  ========================= */
  tabs.forEach(function(tab) {
    var index = tab.getAttribute('data-index');
    var panel = document.querySelector('.gf_tab-panel[data-index="' + index + '"]');

    if (!panel) {
      //console.log("⚠️ No panel found for tab index:", index);
      return;
    }

    let isEmpty = false;

    //console.log("🔍 Checking Tab:", tab.innerText.trim(), "| Index:", index);

    // 🔹 FAQ SPECIAL CHECK
    if (tab.innerText.trim() === "FAQs") {

      const faqItems = panel.querySelectorAll('.faq-list');
      //console.log("📂 FAQ Items Found:", faqItems.length);

      let hasRealContent = false;

      faqItems.forEach((item, i) => {
        const q = item.querySelector('.faq-q-t');
        const a = item.querySelector('.faq-q-ans');

        const qText = q ? q.textContent.replace(/\u00a0/g, '').trim() : '';
        const aText = a ? a.textContent.replace(/\u00a0/g, '').trim() : '';

        //console.log(`➡️ FAQ ${i + 1}:`, { qText, aText });

        if (qText !== '' || aText !== '') {
          hasRealContent = true;
        }
      });

      isEmpty = !hasRealContent;
      //console.log("📊 FAQ has content:", hasRealContent);

    } else {
      // 🔹 NORMAL TAB CHECK
      const cleanText = panel.textContent.replace(/\u00a0/g, '').trim();
      //console.log("📝 Panel Text Length:", cleanText.length);

      isEmpty = cleanText === '';
    }

    // 🔻 HIDE IF EMPTY
    if (isEmpty) {
      //console.log("❌ Hiding Tab:", tab.innerText.trim());
      tab.style.display = "none";
      panel.style.display = "none";
    } else {
      //console.log("✅ Keeping Tab:", tab.innerText.trim());
    }
  });

  /* =========================
     STEP 2: FIX ACTIVE TAB
  ========================= */
  var visibleTabs = Array.from(tabs).filter(tab => tab.style.display !== "none");

  //console.log("👀 Visible Tabs:", visibleTabs.length);

    if (visibleTabs.length > 0) {
      tabs.forEach(tab => tab.classList.remove('gf_tab-active'));
      panels.forEach(panel => panel.classList.remove('active'));

    var firstTab = visibleTabs[0];
    var firstIndex = firstTab.getAttribute('data-index');

    //console.log("🎯 Activating First Visible Tab:", firstTab.innerText.trim());

      firstTab.classList.add('gf_tab-active');

    var firstPanel = document.querySelector('.gf_tab-panel[data-index="' + firstIndex + '"]');
      if (firstPanel) {
        firstPanel.classList.add('active');
      }
    }

  /* =========================
     STEP 3: TAB CLICK LOGIC
  ========================= */
  tabs.forEach(function(tab) {
    tab.addEventListener('click', function() {

      if (this.style.display === "none") {
        //console.log("⛔ Click ignored (hidden tab):", this.innerText.trim());
        return;
      }

      var index = this.getAttribute('data-index');

      //console.log("🖱 Tab Clicked:", this.innerText.trim(), "| Index:", index);

      tabs.forEach(tab => tab.classList.remove('gf_tab-active'));
      panels.forEach(panel => panel.classList.remove('active'));

      this.classList.add('gf_tab-active');

      var target = document.querySelector('.gf_tab-panel[data-index="' + index + '"]');
      if (target) {
        target.classList.add('active');
      }
    });
  });

  document.addEventListener("mousemove", startAfterDelay);

});